// @ts-nocheck

import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';

import { Minus, Plus } from '../../../assets/svg';
import { __, getDecimalSeparator } from '../../../i18n/l10n';
import { Button } from '../../../styled-components/shared';

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  margin: 0.5em 0;
  border-radius: 2px;
  box-shadow: inset 0 0.2em 0.2em rgba(0, 0, 0, 0.8);
  ::after {
    content: '';
    display: block;
    clear: both;
  }
`;

const Input = styled.div`
  && {
    color: ${({ $isValid }) => ($isValid ? '#fff' : '#ddd')};
    font-weight: 600;
    line-height: 3em;
    margin: 0;
    width: calc(100% - 6em);
    height: 3em;
    border: 0;
    padding: 0 0.4em;
    text-align: right;
    float: left;
    background: rgba(255, 255, 255, 0.4);
    box-shadow: inset 0 4px 4px rgba(0, 0, 0, 0.7);
  }
`;

const InputValue = styled.div`
  display: inline-block;
  width: 100%;
  overflow: hidden;
`;

const StyledButton = styled(Button)`
  && {
    width: 3em;
    height: 3em;
    padding: 0;
    float: left;
    border: 0;
    background: #000;
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const commonPicto = css`
  color: #fff;
  width: 1.8em;
  height: 1.8em;
  pointer-events: none;
`;

const MinusIcon = styled(Minus)`
  ${commonPicto}
`;

const PlusIcon = styled(Plus)`
  ${commonPicto}
`;

const StakeInput = (props) => {
  const { onChange, onClickMinus, onClickPlus, readOnly, stake } = props;

  const handleChange = useCallback((e) => onChange(e.target.value), [onChange]);

  return (
    <Wrapper>
      <StyledButton onClick={readOnly ? null : onClickMinus}>
        <MinusIcon />
      </StyledButton>
      <Input $isValid={stake || stake === 0} type="text" readOnly onChange={handleChange} onClick={props.onClick}>
        <InputValue>
          {stake || stake === 0 ? String(stake).replace('.', getDecimalSeparator()) : __('Wager')}
        </InputValue>
      </Input>
      <StyledButton onClick={readOnly ? null : onClickPlus}>
        <PlusIcon />
      </StyledButton>
    </Wrapper>
  );
};

export default StakeInput;
